import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { UploadOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Upload, Button, Tabs } from 'antd';
import { InputField, DatePickerField, TextAreaField, SelectField, CheckboxField } from 'FormFields'
import IconButton from '../../../../Components/IconButton'
import Revisions from '../Revisions'

import paint from './Misc/paints'
import accessEquipment from './Misc/accessEquipment'

const labelColSpan = 6
const wrapperColSpan = 16

export default class _Fields_ extends React.PureComponent {

  static propTypes = {
    clientContacts: PropTypes.array.isRequired,
    hsUsers: PropTypes.array.isRequired,
    serviceTypes: PropTypes.array.isRequired,
    userSettings: PropTypes.array.isRequired,
    files: PropTypes.array.isRequired,
    submitting: PropTypes.bool,
    onBeforeUpload: PropTypes.func.isRequired,
    onChangeFiles: PropTypes.func.isRequired,
    onClickNewClientContact: PropTypes.func.isRequired,
  }

  static defaultProps = {
    submitting: null,
  }

  state = {
    activeTab: '1',
  }

  render () {

    const {
        clientContacts,
        hsUsers,
        serviceTypes,
        userSettings,
        files,
        submitting,
        onBeforeUpload,
        onChangeFiles,
        onClickNewClientContact,
    } = this.props

    let ppe = userSettings.ppe;
    let training = userSettings.training;
    let tasks = userSettings.tasks || [];
    let coshh = userSettings.coshh || [];

    let access = accessEquipment;
    if (userSettings.access.length > 0)
        access = userSettings.access;


    let paints = paint;
    if (userSettings.paints.length > 0)
        paints = userSettings.paints;

    var self = this;

    return (
    <div>
        <Tabs activeKey={this.state.activeTab} onChange={function(key) { self.setState({ activeTab: key }) }}>

          <Tabs.TabPane tab="Job & site" key="1">
            <div style={{ padding: '16px 0' }}>

              <div style={{ display: 'flex', gap: 16 }}>
                <div style={{ flex: 1 }}>
                  <Field
                    name="client_contact_id"
                    label="Contact"
                    disabled={submitting}
                    component={SelectField}
                    options={clientContacts.map(({ id, full_name: fullName }) => ({ label: fullName, value: id }))}
                    renderAfter={() => (
                      <IconButton
                        type="plus-circle"
                        tooltip="New Contact"
                        onClick={onClickNewClientContact}
                        style={{ marginBottom: -4 }}
                      />
                    )}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    fieldCol={{ span: 22 }}
                    afterCol={{ span: 2 }}
                    required
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Field
                    name="hs_contact_id"
                    label="H&S Contact"
                    disabled={submitting}
                    component={SelectField}
                    options={hsUsers.map(({ id, name }) => ({ label: name, value: id }))}
                    placeholder="Select H&S contact"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    required
                  />
                </div>
              </div>

              <div style={{ display: 'flex', gap: 16 }}>
                <div style={{ flex: 1 }}>
                  <Field
                    name="valid_from"
                    label="Valid from"
                    disabled={submitting}
                    component={DatePickerField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    required
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Field
                    name="valid_to"
                    label="Valid to"
                    disabled={submitting}
                    component={DatePickerField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    required
                  />
                </div>
              </div>

              <div style={{ display: 'flex', gap: 16 }}>
                <div style={{ flex: 1 }}>
                  <Field
                    name="scope"
                    label="Scope"
                    disabled={submitting}
                    component={TextAreaField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    style={{ height: 80 }}
                    required
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Field
                    name="notes"
                    label="Notes"
                    disabled={submitting}
                    component={TextAreaField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    style={{ height: 80 }}
                  />
                </div>
              </div>

              <div style={{ border: '1px solid #d9a0a0', borderRadius: 6, padding: 16, marginTop: 8, marginBottom: 8, background: '#fff5f5' }}>
                <div style={{ fontWeight: 'bold', marginBottom: 8, color: '#a8071a', textTransform: 'uppercase', fontSize: 12 }}>Nearest A&E</div>
                <div style={{ display: 'flex', gap: 16 }}>
                  <div style={{ flex: 1 }}>
                    <Field
                      name="nearest_ae_name"
                      label="Hospital name"
                      disabled={submitting}
                      component={InputField}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Field
                      name="nearest_ae_address"
                      label="Address"
                      disabled={submitting}
                      component={InputField}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    />
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 16, marginTop: 8 }}>
                <div style={{ flex: 1 }}>
                  <Field
                    name="site_access"
                    label="Site access"
                    disabled={submitting}
                    component={TextAreaField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    style={{ height: 80 }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Field
                    name="deliveries"
                    label="Deliveries"
                    disabled={submitting}
                    component={TextAreaField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    style={{ height: 80 }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Field
                    name="welfare"
                    label="Welfare"
                    disabled={submitting}
                    component={TextAreaField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    style={{ height: 80 }}
                  />
                </div>
              </div>

            </div>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Activities" key="2">
            <div style={{ padding: '16px 0' }}>

              <Field
                name="services"
                label="Services"
                disabled={submitting}
                component={SelectField}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                required
                mode="multiple"
                options={serviceTypes.filter(serviceType => serviceType.key !== 'O').map(serviceType => ({
                  value: serviceType.key,
                  label: serviceType.title,
                }))}
              />

              <div style={{ display: 'flex', gap: 16 }}>
                <div style={{ flex: 1 }}>
                  <Field
                    name="tasks"
                    label="Tasks"
                    disabled={submitting}
                    component={SelectField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    mode="multiple"
                    options={tasks.map(task => ({
                      value: task.key,
                      label: task.value,
                    }))}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Field
                    name="spray_timing"
                    label="Working hours"
                    disabled={submitting}
                    component={SelectField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    mode="multiple"
                    options={[{"value":"TBC","label":"TBC"},{"value":"In Hours","label":"In Hours"},{"value":"Out of Hours","label":"Out of Hours"},{"value":"Nights","label":"Nights"},{"value":"Weekends","label":"Weekends"}]}
                  />
                </div>
              </div>

            </div>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Hazards & controls" key="3">
            <div style={{ padding: '16px 0' }}>

              <div style={{ display: 'flex', gap: 16 }}>
                <div style={{ flex: 1 }}>
                  <Field
                    name="access_equipment"
                    label="Equipment"
                    disabled={submitting}
                    component={SelectField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    mode="tags"
                    options={access.sort().map(item => ({
                      value: item.key,
                      label: item.value,
                    }))}
                    tokenSeparators={[',']}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Field
                    name="ppe"
                    label="PPE"
                    disabled={submitting}
                    component={SelectField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    mode="multiple"
                    options={ppe.map(ppe => ({
                      value: ppe.key,
                      label: ppe.value,
                    }))}
                  />
                </div>
              </div>

              <div style={{ display: 'flex', gap: 16 }}>
                <div style={{ flex: 1 }}>
                  <Field
                    name="paints"
                    label="Paints"
                    disabled={submitting}
                    component={SelectField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    mode="tags"
                    options={paints.sort().map(item => ({
                      value: item.name,
                      label: item.name,
                    }))}
                    tokenSeparators={[',']}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Field
                    name="coshh"
                    label="COSHH"
                    disabled={submitting}
                    component={SelectField}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    mode="multiple"
                    options={coshh.map(item => ({
                      value: item.key,
                      label: item.value,
                    }))}
                  />
                </div>
              </div>

            </div>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Training" key="4">
            <div style={{ padding: '16px 0' }}>

              <Field
                name="training"
                label="Training requirements"
                disabled={submitting}
                component={SelectField}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                mode="multiple"
                options={training.map(training => ({
                  value: training.key,
                  label: training.value,
                }))}
              />

              <Field
                name="induction_requirements"
                label="Induction requirements"
                disabled={submitting}
                component={TextAreaField}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                style={{ height: 80 }}
              />

            </div>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Files" key="5">
            <div style={{ padding: '16px 0' }}>

              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                <span style={{ marginRight: 8 }}>Suppress RAMS generation (upload PDF manually)</span>
                <Field
                  name="manual_pdf_upload"
                  disabled={submitting}
                  component={CheckboxField}
                />
              </div>

              <div style={{ marginBottom: 16, padding: 12, background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 4 }}>
                <div style={{ fontSize: 12, color: '#389e0d' }}>
                  Check the box above to suppress automatic RAMS document generation.
                  When checked, upload a single PDF file to use as the RAMS document.
                  Upload additional files to attach them as supplementary documents.
                </div>
              </div>

              <Upload
                multiple
                fileList={files}
                beforeUpload={onBeforeUpload}
                onChange={onChangeFiles}
                disabled={submitting}
              >
                <Button disabled={submitting}>
                  <UploadOutlined /> Select Files
                </Button>
              </Upload>

            </div>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Revisions" key="6">
            <Revisions />
          </Tabs.TabPane>

        </Tabs>
    </div>
    );
  }
}
